<template>
  <div class="content">
    <div class="select">
      <span class="form-item">性别</span>
      <Slider :value.sync="sexValue" @update:value="sexValue = $event" />
    </div>
    <div class="select" @click="onShowAgePicker">
      <span class="form-item">年龄</span>
      <span class="form-item">{{ pickerData[ageSelectedIndex].text }}</span>
    </div>
    <div class="submit" @click="onSubmit">
      提交
    </div>
  </div>
</template>
<script>
import Slider from './components/Slider.vue';

export default {
  name: 'ModifySelfInspection',
  components: { Slider },
  data: () => {
    return {
      sexValue: '', // 性别
      pickerData: [], // 年龄可以选择的值
      ageSelectedIndex: [], // 当前被选择的年龄索引，默认25岁
    };
  },
  created() {
    this.sexValue = this.$route.query.sex === '女' ? 'female' : 'male';
    // 准备选择年龄的数据
    for (let i = 1; i <= 130; i++) {
      if (i <= 11) {
        this.pickerData.push({
          text: `${i}个月`,
          value: `${i}个月`,
        });
      } else {
        this.pickerData.push({
          text: `${i - 11}岁`,
          value: `${i - 11}岁`,
        });
      }
    }
    const ageIndex = this.pickerData.findIndex(
      item => item.value === this.$route.query.age
    );
    this.ageSelectedIndex = [ageIndex !== -1 ? ageIndex : 35];
  },
  methods: {
    /**
     * 年龄选择点击事件
     */
    onShowAgePicker() {
      // 调起piacker
      this.picker = this.$createPicker({
        title: '',
        data: [this.pickerData],
        selectedIndex: this.ageSelectedIndex,
        onSelect: this.onAgeSelect,
      });
      this.picker.show();
    },
    /**
     * piacker确认事件
     *
     * @param {Array} selectedVal 当前选中项每一列的值
     * @param {Array} selectedIndex 当前选中项每一列的索引
     */
    onAgeSelect(selectedVal, selectedIndex) {
      this.ageSelectedIndex = [selectedIndex];
    },
    /**
     * 提交按钮点击事件，跳转人体自诊页面
     */
    onSubmit() {
      const { is_login } = this.$route.query;
      window.location.replace(
        `/api/patient_profile/main/?tab_type=usermain&age=${
          this.pickerData[this.ageSelectedIndex].text
        }&sex=${
          this.sexValue === 'male' ? '男' : '女'
        }&from=self_ex&is_login=${is_login || ''}`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  .select {
    display: flex;
    justify-content: space-between;
    height: rem(50);
    padding: rem(15) rem(18);
    border-bottom: 0.5px solid #e7e7e7;
    .form-item {
      color: #323232;
      font-size: rem(15);
      line-height: rem(17);
      letter-spacing: 0;
      text-align: center;
    }
  }
  .submit {
    margin: rem(40) rem(15);
    color: #39d167;
    font-size: rem(16);
    line-height: rem(44);
    letter-spacing: 0;
    border: 0.5px solid #39d167;
    border-radius: rem(22);
  }
}
::v-deep .cube-picker-confirm {
  line-height: 30px;
}
</style>
